module.exports = __webpack_public_path__ + "img/bench-arrangement.c512ac1e.jpg";